import * as React from 'react'
import * as st from './withFatalCheck.module.scss'
import { withLogger, ILogger } from '../../context/withLogger'
import { IDetailPageState } from '../../reducers'
import {
  sanitizedRequestContextSelector,
  IRequestContext
} from '../../selectors/requestContext'
import { connect } from 'react-redux'

export interface IFatal {
  error: string
}

type StateProps = {
  requestContext: IRequestContext
}

export type DataOrFatal<T> = T | IFatal

export const createDataFatal = (
  selectorName: string,
  msg?: string
): IFatal => ({
  error: `fatal in ${[selectorName, msg].filter(Boolean).join(': ')}`
})

export function isFatal<T>(props: DataOrFatal<T>): props is IFatal {
  if (!props) {
    return false
  }
  return Boolean((props as IFatal).error)
}

const FatalComponentWithLogger: React.ComponentType<
  IFatal & ILogger & StateProps
> = props => {
  const {
    requestContext: { isInternal },
    error,
    logger
  } = props
  if (isInternal) {
    const fatalMessage = `Fatals found in Data: ${error}`
    logger.error(fatalMessage)
    return <div className={st.error}>{fatalMessage}</div>
  } else {
    return null
  }
}

const mapStateToProps = (state: IDetailPageState): StateProps => ({
  requestContext: sanitizedRequestContextSelector(state)
})

export const FatalComponent = connect(mapStateToProps)(
  withLogger(FatalComponentWithLogger)
)

export const withFatalCheck = <T extends object>(
  Component: React.ComponentType<T>
): React.ComponentType<DataOrFatal<T>> => (props: DataOrFatal<T>) => {
  if (isFatal(props)) {
    return <FatalComponent {...props} />
  } else {
    return (
      <Component {...props} />
    )
  }
}
